<script lang="ts">
	import { DefaultListItem, PortableText } from '@portabletext/svelte';
	import { goto } from '$app/navigation';
	import theme from 'stores/theme';
	import TaggedHeading from 'components/LearnPage/TaggedHeading/TaggedHeading.svelte';
	import BlankedLink from 'components/LearnPage/BlankedLink/BlankedLink.svelte';
	import LinkBack from 'components/LinkBack/LinkBack.svelte';
	import NewsList from 'components/NewsBlock/NewsList/NewsList.svelte';
	import SanityImage from 'components/SanityImage/SanityImage.svelte';
	import { generateTreeForPost } from 'utils/learn/generateTree';
	import { dateToTimeAgo } from 'utils/time';
	import { _ } from 'svelte-i18n';
	import SanityTable from 'components/SanityTable/SanityTable.svelte';
	import SanityFaq from 'components/SanityFAQ/SanityFAQ.svelte';
	import MetaTags from 'components/MetaTags/MetaTags.svelte';
	import Page from '../+page.svelte';
	import SchemaOrgLearnPage from 'components/SchemaOrg/SchemaOrgLearnPage.svelte';

	export let data;

	$: ({ article } = data);
	$: dark = $theme;
	$: menuTree = article?.title && generateTreeForPost(article);
</script>

{#if article?.title}
	<SchemaOrgLearnPage
		title={article.title}
		datePublished={article._createdAt}
		dateModified={article._updatedAt}
		img={article.mainImage.src}
		author={article.author?.trim()}
		slug={article.slug.current}
	/>
	<MetaTags title={`${article.metaTitle} | CryptoMarketCap`} description={article.metaDescription} />

	<div class="container">
		<article class="article" class:dark>
			<section class="article-head">
				<div class="heading">
					<div class="back-btn">
						<LinkBack to="/learn" />
					</div>
					<h1 class="article-title">{article.title}</h1>
				</div>
				<img
					src={article.mainImage.src}
					alt={article.mainImage.alt}
					width="728"
					height="410"
					class="image"
				/>

				<ul class="metadata-list">
					<li class="list-item">{$_('learn.by')} {article.author}</li>
					<li class="list-item">
						{$_('learn.published')}
						{dateToTimeAgo(new Date(article._createdAt))}
					</li>
					<li class="list-item">{article.readingTime} {$_('learn.minsRead')}</li>
				</ul>
			</section>
			<p class="tag">{article.category?.replaceAll('_', ' ')}</p>
			{#if menuTree.children}
				<nav class="table-contents">
					<p class="title">{$_('learn.tableOfContents')}</p>
					<ul class="topics-list">
						{#each menuTree.children as menuItem}
							<li class="topic">
								<a href={`#${menuItem.slug}`}>{menuItem.title}</a>
							</li>
						{/each}
					</ul>
				</nav>
			{/if}

			<div class="typography-page content" class:dark>
				<PortableText
					value={article.body}
					components={{
						block: {
							h1: TaggedHeading,
							h2: TaggedHeading,
							h3: TaggedHeading,
							h4: TaggedHeading,
							h5: TaggedHeading,
							h6: TaggedHeading,
						},
						marks: {
							link: BlankedLink,
						},
						types: {
							image: SanityImage,
							table: SanityTable,
							faqList: SanityFaq,
						},
						listItem: {
							normal: DefaultListItem,
						},
					}}
					context={{ dark }}
				/>
			</div>
		</article>
	</div>

	{#if article.related}
		<p class="article-title sub">{$_('learn.relatedArticles')}</p>
		<div class="news-wrapper" class:dark>
			<NewsList {dark} isNewsPage={true} withUpdateOption={false} list={article.related} />
		</div>
	{/if}

	<button
		class="more-btn"
		type="button"
		on:click={() => {
			goto(`/learn`);
		}}>{$_('learn.articlesButton')}</button
	>

	<style lang="scss">
		@import 'article';
	</style>
{:else}
	<Page {data} />
{/if}
